<template>
  <div class="flex flex-col gap-y-3">
    <div v-if="dateTimes.first && dateTimes.first.length">
      <h3 v-if="dateTimes.second && dateTimes.second.length" class="font-bold">First Session</h3>
      <DataTable :value="dateTimes.first" table-style="width: 100%">
        <Column field="time" header="Time" style="width: 75%" />
        <Column field="location" header="Location" style="width: 25%">
          <template #body="slotProps">
            <a
              v-if="slotProps.data.locationURL"
              :href="`${slotProps.data.locationURL}`"
              target="_blank"
              rel="noopener noreferrer"
              class="text-text-secondary wrap-break-word"
              ><u>{{ slotProps.data.location }}</u></a
            >
            <span v-else class="wrap-break-word">{{ slotProps.data.location }}</span>
          </template>
        </Column>
      </DataTable>
    </div>
    <div v-if="dateTimes.second && dateTimes.second.length">
      <h3 v-if="dateTimes.first && dateTimes.first.length" class="font-bold">Second Session</h3>
      <DataTable :value="dateTimes.second" table-style="width: 100%">
        <Column field="time" header="Time" style="width: 75%" />
        <Column field="location" header="Location" style="width: 25%">
          <template #body="slotProps">
            <a
              v-if="slotProps.data.locationURL"
              :href="`${slotProps.data.locationURL}`"
              target="_blank"
              rel="noopener noreferrer"
              class="text-text-secondary wrap-break-word"
              ><u>{{ slotProps.data.location }}</u></a
            >
            <span v-else class="wrap-break-word">{{ slotProps.data.location }}</span>
          </template>
        </Column>
      </DataTable>
    </div>
  </div>
</template>

<script setup lang="ts">
import { ParsedMeetingTime } from '../../types/app_state.types'

defineProps<{
  dateTimes: Record<string, ParsedMeetingTime[] | null>
}>()
</script>
